// extracted by mini-css-extract-plugin
export default {"closeBtnContainer":"MultiFormFrascos_closeBtnContainer__U7ngH"};